var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotApplicable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.724.274a.937.937 0 00-1.325 0l-6.475 6.474A12.135 12.135 0 0016 3.812C9.279 3.812 3.812 9.279 3.812 16c0 3.023 1.107 5.792 2.936 7.925L.274 30.399a.937.937 0 101.325 1.326l6.475-6.474a12.135 12.135 0 007.925 2.936c6.72 0 12.187-5.467 12.187-12.188 0-3.023-1.107-5.792-2.936-7.925L31.724 1.6a.937.937 0 000-1.326zM5.687 16c0-5.686 4.626-10.312 10.312-10.312 2.506 0 4.806.9 6.595 2.391L8.078 22.595A10.265 10.265 0 015.687 16zm20.624 0c0 5.687-4.626 10.313-10.312 10.313-2.506 0-4.806-.9-6.595-2.391L23.92 9.404A10.265 10.265 0 0126.311 16z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/not-applicable.91343f01106cf1da1d2d679dd8108444.svg";
export { SvgNotApplicable as ReactComponent };